import React from 'react';
import { FieldGroup } from '../../components';

import './card-type.scss';

export function CardType({ value, onChange, readOnly }) {
  return (
    <div className="card-type">
      <FieldGroup
        name="card_type"
        type="select"
        options={[
          { id: 'visa', name: <div><img src="/assets/visa.png" height="30px" width="60px"/></div> },
          { id: 'mastercard', name: <div><img src="/assets/mastercard.png" height="30px" width="60px"/></div> },
          { id: 'amex',name: <div><img src="/assets/amex.png" height="30px" width="60px"/></div> },
          { id: 'discover', name: <div><img src="/assets/discover.png" height="30px" width="60px"/></div> },
          { id: 'other', name: <div className="card-other">Other</div> },
        ]}
        placeholder=""
        value={value}
        onChange={onChange}
        noFormik
        disabled={readOnly}
      />
    </div>
  );
}
